<template>
    <svg
        id="File_Excel"
        data-name="File Excel"
        xmlns="http://www.w3.org/2000/svg"
        width="16.884"
        height="20.61"
        viewBox="0 0 16.884 20.61"
    >
        <path
            id="Pfad_366"
            data-name="Pfad 366"
            d="M54.434,20.61H40.313a1.334,1.334,0,0,1-1.382-1.277V1.278A1.334,1.334,0,0,1,40.313,0H48.7a.847.847,0,0,1,.588.234l6.308,6.152a.721.721,0,0,1,.223.516V19.333a1.334,1.334,0,0,1-1.382,1.277m-13.881-1.5H54.194V7.2L48.348,1.5h-7.8Z"
            transform="translate(-38.931)"
            fill="#217346"
        />
        <path
            id="Pfad_367"
            data-name="Pfad 367"
            d="M54.346,7.832h-5.79a1.463,1.463,0,0,1-1.51-1.407V.75h1.622V6.332h5.679Z"
            transform="translate(-38.274 0)"
            fill="#217346"
        />
        <path
            id="Pfad_368"
            data-name="Pfad 368"
            d="M48.8,10.761H46.167V12.6H48.5v.838H46.167v1.917H48.8v.838H45.058V9.924H48.8Z"
            transform="translate(-38.435 0)"
            fill="#217346"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "FileExcelIcon",
    props: {},
});
</script>
